import React from "react"
import {PropertyPriceSummary} from "@/types/Property"

const PLACEHOLDER = "—"

const isFiniteNumber = (value: unknown): value is number =>
   typeof value === "number" && Number.isFinite(value)

const formatMoney = (value: unknown) =>
   isFiniteNumber(value)
      ? `$${value.toLocaleString("en-US", {
           minimumFractionDigits: 0,
           maximumFractionDigits: 0,
        })}`
      : PLACEHOLDER

const formatSurface = (value: unknown) =>
   isFiniteNumber(value) ? `${value.toLocaleString("es-MX")} m²` : PLACEHOLDER

function PropertyPriceSummaryTable({property}: {property: PropertyPriceSummary}) {
   const surface = property.mtsConstruction || property.mts

   return (
      <div className="mb-5 w-full max-w-full overflow-hidden rounded border border-gray-200 sm:w-fit">
         <table className="w-full table-fixed border-collapse text-[11px] text-gray-500 sm:hidden">
            <thead>
               <tr className="bg-blue text-white">
                  <th
                     className="break-words border border-blue px-1 py-1 text-left font-semibold"
                     colSpan={2}
                  >
                     Inmueble
                  </th>
                  <th
                     className="break-words border border-blue px-1 py-1 text-center font-semibold"
                     colSpan={2}
                  >
                     Precio de venta
                  </th>
                  <th
                     className="break-words border border-blue px-1 py-1 text-center font-semibold"
                     colSpan={2}
                  >
                     Sup.
                  </th>
               </tr>
            </thead>
            <tbody>
               <tr className="bg-white">
                  <td
                     className="break-words border border-gray-200 px-1 py-2 text-sm font-normal text-gray-900"
                     colSpan={2}
                  >
                     {property.name || PLACEHOLDER}
                  </td>
                  <td
                     className="break-all border border-gray-200 px-1 py-2 text-center text-sm font-normal"
                     colSpan={2}
                  >
                     {formatMoney(property.costoVenta)}
                  </td>
                  <td
                     className="break-all border border-gray-200 px-1 py-2 text-center text-sm font-normal"
                     colSpan={2}
                  >
                     {formatSurface(surface)}
                  </td>
               </tr>
               <tr className="bg-blue text-white">
                  <th
                     className="break-words border border-blue px-1 py-1 text-center font-semibold"
                     colSpan={3}
                  >
                     Precio m²
                  </th>
                  <th
                     className="break-words border border-blue px-1 py-1 text-center font-semibold"
                     colSpan={3}
                  >
                     Mtto.
                  </th>
               </tr>
               <tr className="bg-white">
                  <td
                     className="break-all border border-gray-200 px-1 py-2 text-center text-sm font-normal"
                     colSpan={3}
                  >
                     {formatMoney(property.pricePerMeter)}
                  </td>
                  <td
                     className="break-all border border-gray-200 px-1 py-2 text-center text-sm font-normal"
                     colSpan={3}
                  >
                     {formatMoney(property.maintenance)}
                  </td>
               </tr>
            </tbody>
         </table>
         <table className="hidden table-auto border-collapse text-sm text-gray-500 sm:table">
            <thead>
               <tr className="bg-blue text-white">
                  <th className="break-words border border-blue px-6 py-2 text-left font-semibold">
                     Inmueble
                  </th>
                  <th className="break-words border border-blue px-6 py-2 text-center font-semibold">
                     Precio de venta
                  </th>
                  <th className="break-words border border-blue px-6 py-2 text-center font-semibold">
                     Sup.
                  </th>
                  <th className="break-words border border-blue px-6 py-2 text-center font-semibold">
                     Precio m²
                  </th>
                  <th className="break-words border border-blue px-6 py-2 text-center font-semibold">
                     Mtto.
                  </th>
               </tr>
            </thead>
            <tbody>
               <tr className="bg-white">
                  <td className="break-words border border-gray-200 px-6 py-2 text-lg font-normal text-gray-900">
                     {property.name || PLACEHOLDER}
                  </td>
                  <td className="break-all border border-gray-200 px-6 py-2 text-center text-lg font-normal">
                     {formatMoney(property.costoVenta)}
                  </td>
                  <td className="break-all border border-gray-200 px-6 py-2 text-center text-lg font-normal">
                     {formatSurface(surface)}
                  </td>
                  <td className="break-all border border-gray-200 px-6 py-2 text-center text-lg font-normal">
                     {formatMoney(property.pricePerMeter)}
                  </td>
                  <td className="break-all border border-gray-200 px-6 py-2 text-center text-lg font-normal">
                     {formatMoney(property.maintenance)}
                  </td>
               </tr>
            </tbody>
         </table>
      </div>
   )
}

export default PropertyPriceSummaryTable
